/**
 * Imperative role taxonomy for agent tool handlers (outside React render).
 * CanvasProvider registers tenant panelData.roleTaxonomy on load/update.
 */
import {
  buildRoleTaxonomyIndex,
  type RoleTaxonomyEntry,
  type RoleTaxonomyIndex,
} from '../canvas/roleTaxonomy';

let taxonomyEntries: RoleTaxonomyEntry[] = [];
let taxonomyIndex: RoleTaxonomyIndex = buildRoleTaxonomyIndex([]);

function isRoleTaxonomyEntry(value: unknown): value is RoleTaxonomyEntry {
  if (typeof value !== 'object' || value === null) return false;
  const row = value as RoleTaxonomyEntry;
  return (
    typeof row.id === 'string' &&
    typeof row.label === 'string' &&
    Array.isArray(row.departments) &&
    Array.isArray(row.synonyms)
  );
}

export function setRoleTaxonomy(entries: readonly unknown[] | undefined): void {
  if (!entries || entries.length === 0) {
    taxonomyEntries = [];
    taxonomyIndex = buildRoleTaxonomyIndex([]);
    return;
  }
  taxonomyEntries = entries.filter(isRoleTaxonomyEntry);
  taxonomyIndex = buildRoleTaxonomyIndex(taxonomyEntries);
}

export function getRoleTaxonomyEntries(): readonly RoleTaxonomyEntry[] {
  return taxonomyEntries;
}

export function getRoleTaxonomyIndex(): RoleTaxonomyIndex {
  return taxonomyIndex;
}
